import { ArrowRight } from "lucide-react";
import videoAsset from "@/assets/whitepaper-backlash.mp4.asset.json";
import posterAsset from "@/assets/whitepaper-backlash-poster.webp.asset.json";
import { LazyVideo } from "./LazyVideo";

export function FutureSection() {


  return (
    <section id="why-it-works" className="border-t border-border/50 bg-[#080E1E]/95 px-5 py-12 sm:px-6 sm:py-16 md:px-8 md:py-20 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="mx-auto mb-8 max-w-2xl text-center sm:mb-10 md:mb-14">
          <p className="text-sm font-semibold tracking-widest text-primary uppercase mb-3">
            THE CASE FOR INTERACTIVE TOOLS
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold leading-tight tracking-tight text-white">
            From Gated Content<br className="md:hidden" /> to Useful Tools.
          </h2>
        </div>

        <div className="grid gap-8 sm:gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 lg:items-center">
          <div className="order-2 lg:order-1 flex flex-col space-y-6 text-muted-foreground leading-relaxed lg:text-lg">
            <div className="space-y-3">
              <p className="text-sm font-semibold tracking-[0.22em] uppercase text-primary">
                Why It Works
              </p>
              <h3 className="text-3xl sm:text-4xl font-semibold leading-tight text-white">
                Give Them an Answer. <span className="text-primary">Not Another PDF.</span>
              </h3>
            </div>
            <div className="space-y-4 max-w-prose">
              <p>
                Traditional lead magnets ask prospects to hand over their information for a generic piece of content.
              </p>
              <p>
                Interactive tools give them something more valuable: an answer that’s specific to them.
              </p>
              <p>
                A calculator can quantify potential savings. An assessment can identify gaps or opportunities. A custom app can help someone plan, evaluate or make a decision.
              </p>
              <p>
                Your prospect gets immediate value. You get a more engaged lead, valuable insights and a natural reason to continue the conversation.
              </p>
            </div>
            <div className="pt-2">
              <a
                href="#lead-generation-tools"
                className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
              >
                See What’s Possible <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative group lg:sticky lg:top-24">
            <div className="overflow-hidden rounded-xl border border-sky-600/30 bg-black shadow-[var(--shadow-glow)] sm:rounded-2xl">
              <LazyVideo
                src={videoAsset.url}
                poster={posterAsset.url}
                showMuteToggle
                ariaLabel="From gated content to useful tools"
              />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
